// Inject style into header to hide nav
var style = document.createElement('style');
style.innerHTML = '.navigation_section__links {display: none;}';

document.getElementsByTagName('head')[0].appendChild(style);